{{ typedText }}<span class="cursor">|</span>
